import { ApiStudentRequest, request } from '../utils'
import { LanguageProficiencyFilesResource } from '@backend/resources/student-document/language-proficiency/types'

export type RawGetLanguageProficiencyFileResponse = {
  data: LanguageProficiencyFilesResource
}

export async function getLanguageProficiencyFile(studentId: string, languageProficiencyId: string) {
  return request<RawGetLanguageProficiencyFileResponse>(
    new ApiStudentRequest(`/documents/language-proficiencies/${languageProficiencyId}/file`, {
      method: 'GET',
    }),
    {
      isExpectedResponse: (res): res is RawGetLanguageProficiencyFileResponse => res as boolean,
    },
  )
}
